var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup43(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "47px",
    height: "47px",
    viewBox: "0 0 47 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5FC4F4F-7A66-46DB-86F2-D2F91CF44BD8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "10.-Who-can-use-Hana-UI",
    transform: "translate(-357.000000, -514.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(358.000000, 515.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.69093,22.34545 C44.69093,34.68645 34.68653,44.69085 22.34543,44.69085 C10.00443,44.69085 3e-05,34.68645 3e-05,22.34545 C3e-05,10.00435 10.00443,-5e-05 22.34543,-5e-05 C34.68653,-5e-05 44.69093,10.00435 44.69093,22.34545 Z",
    id: "Stroke-1",
    stroke: "#222456",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.92174,12.18695 C29.58824,13.37285 33.04014,17.60215 33.04014,22.63765 C33.04014,28.59255 28.21274,33.41985 22.25784,33.41985 C16.30304,33.41985 11.47564,28.59255 11.47564,22.63765 C11.47564,18.17155 14.19104,14.33955 18.06094,12.70265",
    id: "Stroke-3",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8319,9.37123 C14.8319,10.38093 14.0133,11.19943 13.0036,11.19943 C11.9939,11.19943 11.1754,10.38093 11.1754,9.37123 C11.1754,8.36143 11.9939,7.54293 13.0036,7.54293 C14.0133,7.54293 14.8319,8.36143 14.8319,9.37123 Z",
    id: "Stroke-5",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.82858,7.7684 C30.82858,8.7782 30.01008,9.5967 29.00028,9.5967 C27.99058,9.5967 27.17208,8.7782 27.17208,7.7684 C27.17208,6.7586 27.99058,5.9401 29.00028,5.9401 C30.01008,5.9401 30.82858,6.7586 30.82858,7.7684 Z",
    id: "Stroke-7",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.21364,20.82045 C40.21364,21.83025 39.39504,22.64875 38.38534,22.64875 C37.37564,22.64875 36.55714,21.83025 36.55714,20.82045 C36.55714,19.81075 37.37564,18.99225 38.38534,18.99225 C39.39504,18.99225 40.21364,19.81075 40.21364,20.82045 Z",
    id: "Stroke-9",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.60641,35.75502 C33.60641,36.76482 32.78791,37.58332 31.77811,37.58332 C30.76841,37.58332 29.94991,36.76482 29.94991,35.75502 C29.94991,34.74522 30.76841,33.92682 31.77811,33.92682 C32.78791,33.92682 33.60641,34.74522 33.60641,35.75502 Z",
    id: "Stroke-11",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22038,24.02621 C8.22038,25.03601 7.40178,25.85451 6.39208,25.85451 C5.38238,25.85451 4.56388,25.03601 4.56388,24.02621 C4.56388,23.01641 5.38238,22.19791 6.39208,22.19791 C7.40178,22.19791 8.22038,23.01641 8.22038,24.02621 Z",
    id: "Stroke-13",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.60831,37.07836 C17.60831,38.08816 16.78971,38.90666 15.78001,38.90666 C14.77031,38.90666 13.95171,38.08816 13.95171,37.07836 C13.95171,36.06866 14.77031,35.25016 15.78001,35.25016 C16.78971,35.25016 17.60831,36.06866 17.60831,37.07836 Z",
    id: "Stroke-15",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.31911,
    y1: 35.331,
    x2: 18.39361,
    y2: 31.1171,
    id: "Stroke-17",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.82858,
    y1: 34.19242,
    x2: 28.67878,
    y2: 31.29992,
    id: "Stroke-19",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.55709,
    y1: 20.82045,
    x2: 32.94619,
    y2: 21.21175,
    id: "Stroke-21",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.138,
    y1: 9.3807,
    x2: 26.7535,
    y2: 12.8351,
    id: "Stroke-23",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.15099,
    y1: 10.79428,
    x2: 17.10339,
    y2: 14.91048,
    id: "Stroke-25",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.22038,
    y1: 24.02621,
    x2: 13.00368,
    y2: 23.43281,
    id: "Stroke-27",
    stroke: "#222456",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.60167,18.22465 C27.60167,18.96465 27.00167,19.56455 26.26167,19.56455 C25.52157,19.56455 24.92167,18.96465 24.92167,18.22465 C24.92167,17.48465 25.52157,16.88465 26.26167,16.88465 C27.00167,16.88465 27.60167,17.48465 27.60167,18.22465 Z",
    id: "Stroke-29",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.29479,23.72563 C27.29479,24.29623 26.83229,24.75873 26.26169,24.75873 C25.69109,24.75873 25.22859,24.29623 25.22859,23.72563 C25.22859,23.15503 25.69109,22.69253 26.26169,22.69253 C26.83229,22.69253 27.29479,23.15503 27.29479,23.72563 Z",
    id: "Stroke-31",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.11647,27.7099 C23.11647,28.7787 22.25007,29.6451 21.18137,29.6451 C20.11267,29.6451 19.24627,28.7787 19.24627,27.7099 C19.24627,26.6411 20.11267,25.7748 21.18137,25.7748 C22.25007,25.7748 23.11647,26.6411 23.11647,27.7099 Z",
    id: "Stroke-33",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2674,20.82045 C19.2674,21.73675 18.5246,22.47965 17.6083,22.47965 C16.692,22.47965 15.9492,21.73675 15.9492,20.82045 C15.9492,19.90425 16.692,19.16135 17.6083,19.16135 C18.5246,19.16135 19.2674,19.90425 19.2674,20.82045 Z",
    id: "Stroke-35",
    stroke: "#EE7330",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.93019,8.0476 C43.93019,12.2633 40.51269,15.6808 36.29689,15.6808 C32.08119,15.6808 28.66369,12.2633 28.66369,8.0476 C28.66369,3.8319 32.08119,0.4143 36.29689,0.4143 C40.51269,0.4143 43.93019,3.8319 43.93019,8.0476",
    id: "Fill-37",
    fill: "#BE1622"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.04274,
    y1: 5.7934,
    x2: 38.55114,
    y2: 10.3018,
    id: "Stroke-39",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55114,
    y1: 5.7934,
    x2: 34.04274,
    y2: 10.3018,
    id: "Stroke-41",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup43);
export default __webpack_public_path__ + "static/media/Group 43.8995fdd4.svg";
export { ForwardRef as ReactComponent };